import React from "react";
import { PhosphorPlus } from "./PhosphorIcon";

interface PlusMinusButtonProps {
  type: "plus" | "minus";
  icon: JSX.Element;
  onClick: () => void;
}

const PlusMinusButton = (props: React.PropsWithChildren<PlusMinusButtonProps>) => {
  return <button
    className="plus-minus-button-wrapper"
    type="button"
    onClick={props.onClick}
  >
    <span className="plus-minus-button-plus-sign">{props.icon}</span>
    {props.children}
  </button>
}

export const PlusButton = (props: React.PropsWithChildren<Omit<PlusMinusButtonProps, "type" | "icon">>) => {
  return <PlusMinusButton
    type="plus"
    icon={<PhosphorPlus iconSize="regular" iconColor="white" />}
    {...props}
  />
}